import * as React from "react";
import { cn } from "@/shadcn/lib/utils";
import { Loader2Icon } from "lucide-react";

// playerdex · registry v1 · shadcn@4.21.0

const Spinner = React.forwardRef(function Spinner(
  { className, ...props },
  ref
) {
  return (
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      ref={ref}
      {...props}
    />
  );
});

export { Spinner };
